import React, { FC } from "react"
import Styles from "../styles/DrawerMenu.module.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition, IconProp } from "@fortawesome/fontawesome-svg-core";

export type MenuItemType = {
    func: () => void
    name: string | JSX.Element
    icon: IconProp | IconDefinition | null
}

type Props = {
    drawerOpen: boolean,
    setDrawerOpen: ( bool: boolean ) => void,
    menuList: MenuItemType[]
}

const DrawerMenu: FC<Props> = ( {
    drawerOpen,
    setDrawerOpen,
    menuList
} ) =>
    <div
        style={ drawerOpen ? { transform: "translate3d(0,0,0)" } : {} }
        className={ Styles.menu_container } onClick={ () => setDrawerOpen( false ) }>
        <ul style={ drawerOpen ? { transform: "translate3d(0,0,0)" } : {} }>
            { menuList.map( ( menu, index ) =>
                <li
                    onClick={ () => menu.func() }
                    key={ index }>
                    { menu.icon ?
                        <FontAwesomeIcon
                            icon={ menu.icon }
                            className={ Styles.icon }/> :
                        <span className={Styles.icon}></span> }
                    { menu.name }
                </li>
            ) }
        </ul>
    </div>



export default DrawerMenu
